import { minimapPositionRegistry } from '@/controllers/PositionsController';
import { config } from '@/settings/config';
import { useStore } from '@/store/useStore';
import './miniMap.css';
import { useBetOnRacer } from '@/ui/hooks/useBetOnRacer';
import { cn } from '@/ui/lib/utils';

const TRACK_LINES = Array.from({ length: 4 }).map((_, i) => i);

export const Minimap = () => {
    const racers = useStore((state) => state.activeHeroes);
    const betOnRacer = useBetOnRacer();

    return (
        <div className="mini-map">
            <div className="mini-map__track">
                <div className="mini-map__start-line" />
                <div className="mini-map__lines" ref={minimapPositionRegistry.registerContainer}>
                    {racers.map((racer, index) => (
                        <div
                            key={racer.name}
                            className={cn(
                                'mini-map__racer',
                                betOnRacer?.racerId === racer.name &&
                                    'mini-map__racer--highlighted',
                            )}
                            ref={(el) => minimapPositionRegistry.registerRacer(racer.name, el)}
                            style={{
                                backgroundColor:
                                    config.heroColors[racer.name as keyof typeof config.heroColors],
                                top: `calc(${((index + 0.5) / racers.length) * 100}% - 2px)`,
                            }}
                        />
                    ))}
                    {TRACK_LINES.map((line) => (
                        <div className="mini-map__line" key={line}>
                            <div className="mini-map__finish-line">
                                <div className="mini-map__finish-line-dot" />
                                <div className="mini-map__finish-line-dot" />
                            </div>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};
